// Copy for the "AI coordinator credit cap reached" notification (type 119).
export const COORDINATOR_CREDIT_NOTIFICATION_COPY = {
  title: '[Action required] Credit request for AI coordinator in Kula',
  body: "Your team has run out of credits and can't run the AI coordinator until credits are added",
  requestedByLabel: 'Requested by:',
  detailsTitle: 'Details',
  topUpCta: 'Top up credits',
  supportCta: 'Contact support',
} as const;
